import { DecalGeometry } from 'three/examples/jsm/geometries/DecalGeometry'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { useRef, useState } from 'react'
import NormalizedModel from './NormalizedModel'
import Sticker from './Sticker'
import { Canvas } from '@react-three/fiber'
import { OrbitControls, Bounds } from '@react-three/drei'


export default function Viewer360({
  modelUrl,
  selectedMeshName,
  onMeshesLoaded
}) {
  return (
    <div className="canvas-container">
                  <Canvas
              style={{ width: '100%', height: '100%' }}
              camera={{ position: [0, 2.5, 7], fov: 40 }}
            >
              <ambientLight intensity={0.9} />
              <directionalLight position={[5, 5, 5]} />

              <NormalizedModel
                url={modelUrl}
                selectedMeshName={selectedMeshName}
                onMeshesLoaded={onMeshesLoaded}
              />

              <OrbitControls
                target={[0, 0.9, 0]}
                enablePan={false}
                minDistance={3}
                maxDistance={10}
              />
            </Canvas>
    </div>
  )
}




